import img1 from "../../images/tourismInMexico.jpg";
import img2 from "../../images/candids.jpg";
import img3 from "../../textiles_png/8_textiles/8425.jpg";
import img4 from "../../textiles_png/8_textiles/educational_textile.jpg";
import img5 from "../../images/8-1_85_185_50A_crop.jpg";
import img6 from "../../images/8_ceramics.png";

export const tourismObjOne = {
    id : 'SectionOne',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    headline: "Tourism and the Saltillo",
    description: "The Mexican nationalist movement of the early 1900s, appropriated the country’s Spanish and Indigenous identities to create a hybrid “Mexican” identity. The Saltillo sarape turned out to be one of the country’s most enduring symbols. This period saw the rise of the rainbow-striped blanket, which became synonymous with Mexico through its use in films, posters, and advertising. ",
    description2: "As tourism to Mexico increased, many visitors purchased these colorful sarapes as souvenirs. With demand on the rise, sarape-manufacturing plants were established. Through the use of electric-powered looms, synthetic dyes, and acrylic yarns, production time was shortened and the number of textiles increased. As a result, by the 1930s, there was a drastic decline in handwoven sarapes and the use of natural-dyed yarns. This poster promoting Mexican Tourism has iconic symbols of Mexico: A saguaro, a sombrero, a guitar, pyramids, and a colorful, striped Saltillo Sarape.",
    description3: "This poster promoting Mexican tourism has iconic symbols of Mexico: a saguaro, a sombrero, a guitar, pyramids, and a colorful, striped Saltillo sarape.",
    buttonLabel: "",
    imgStart: true,
    img:null,
    artifact: img5,
    artifactAlt: 'Color Lithograph',
    artifactInfo: 'Color Lithograph, 1945. Jose Espert Arcos, graphic designer. Asociacion Mexicana de Turismo, Mexico. Harry Ransom Center. The University of Texas at Austin, Texas War Records Travel Posters Collection, 85.185.50A',
    dark: true,
    primary: true,
    darkText: false
};

export const tourismObjTwo = {
    id : 'SectionTwo',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    description: "Mexican ceramic artists in the area of Guadalajara responded to the tourist market by creating miniature scenes of Mexican people from the 1800s. Often, the male figures who rode or worked with horses were depicted wearing Saltillo sarapes.",
    description2:"The attire of the two male figures wrapped in Saltillo sarapes indicates they are part of the upper class. The vaquero carries a sarape rolled up behind his saddle. ",
    buttonLabel: "",
    imgStart: true,
    artifact: img6,
    artifactAlt:'Ceramic Figurines',
    artifactInfo:'Ceramic Figurines, c. 1900-1920. ASM 156',
    dark: true,
    primary: true,
    darkText: false
};

export const tourismObjThree = {
    id : 'SectionThree',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    description: "This photo shows tourists wearing Saltillo sarapes and sombreros while visiting Tijuana, Mexico. These items would have been purchased as souvenirs and gifts, increasing their recognition as symbols of Mexico.",
    description2: "Tourist Photograph, May 5, 1920. Tijuana, Mexico. Loan from Tom Kieft",
    buttonLabel: "",
    imgStart: true,
    img: img1,
    artifact: img3,
    smallImg: true,
    artifactAlt: "Sarape",
    artifactInfo: 'Rainbow-striped Saltillo Sarape c. 1900, Wool, cotton, and synthetic dyes, ASM Purchase from Nelle A. Dermont, 1919, 8425',
    alt: 'Paper',
    dark: true,
    primary: true,
    darkText: false
};

export const tourismObjFour = {
    id : 'SectionFour',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    description: "Oaxaca continues to be an important weaving center whose textiles are sold worldwide. Most Zapotec weavers now use synthetic dyes, rather than the traditional natural dyes, which cuts down on the work and makes production faster.",
    description2: "Zapotec Textiles on Sale at the Arizona State Museum's Southwest Indian Art Fair. Alanah K. Tupponce, Photographer, 2011.",
    buttonLabel: "",
    imgStart: true,
    img: img2,
    smallImg: true,
    artifact: img4,
    artifactAlt: 'Morning Stars',
    artifactInfo: 'Morning Stars. Zapotec Textile. Wool, cotton, and synthetic dyes. ASM purchase for education collection, 2020',
    alt: 'Paper',
    dark: true,
    primary: true,
    darkText: false
};